import {PureComponent} from 'react'
import PropTypes from 'prop-types'

export default class Modal extends PureComponent {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    closing: PropTypes.bool,
    isOpen: PropTypes.bool.isRequired,
    cancelClose: PropTypes.func
  }

  async onModalClose() {
    return true
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.closing && this.props.closing) {
      this
        .onModalClose()
        .then((close) => {
          if (close) {
            this.props.closeModal(true)
          } else {
            this.props.cancelClose()
          }
        })

    }
  }
}
